export default {
  home: {
    hero: {
      badge: 'Niezależne centrum zasobów',
      title: 'USFans Spreadsheet — Kompletne centrum zasobów',
      subtitle: 'Znajdź zasoby USFans spreadsheet, recenzje, informacje o wysyłce, kupony, porównania i praktyczne poradniki — wszystko w jednym miejscu.',
      ctaMain: 'usfans spreadsheet',
      ctaBuy: 'kup teraz',
      ctaGuide: 'Przeczytaj pełny poradnik',
      trust: 'Niezależne źródło • Aktualizowane poradniki • Wielojęzyczne • Dbające o bezpieczeństwo',
    },
    what: {
      title: 'Czym jest USFans Spreadsheet?',
      p1: 'USFans Spreadsheet to uporządkowany, katalog oparty na kategoriach amerykańskich gadżetów. Porządkuje popularne typy produktów — od obuwia i nakryć głowy po akcesoria i perfumy — w prostą, przejrzystą strukturę, dzięki czemu zawsze wiesz, gdzie szukać.',
      p2: 'Zamiast otwierać dziesiątki kart lub zgadywać, gdzie znajduje się produkt, możesz przejść bezpośrednio do pasującej kolekcji za pomocą jednego, czytelnego linku. Ma to na celu zmniejszenie tarcia i pomóc fanom oraz kupującym szybciej znaleźć to, czego chcą.',
    },
    categories: {
      title: 'Przeglądaj popularne kategorie',
      subtitle: 'Wybierz kategorię poniżej, aby przejść bezpośrednio do pasującej kolekcji na naszej głównej stronie.',
      dropdownLabel: 'Wybierz kategorię',
      dropdownPlaceholder: 'Wybierz kategorię...',
      gridCta: 'Odkryj',
    },
    why: {
      title: 'Dlaczego warto korzystać z USFans Spreadsheet?',
      f1title: 'Przejrzysta organizacja',
      f1text: 'Każdy typ produktu jest pogrupowany w prostą, przewidywalną kategorię — bez bałaganu i zgadywania.',
      f2title: 'Szybki dostęp',
      f2text: 'Bezpośrednie linki przenoszą Cię do dokładnej kolekcji jednym kliknięciem, pomijając niekończące się wyszukiwanie i filtrowanie.',
      f3title: 'Zawsze aktualne',
      f3text: 'Zasób jest utrzymywany i aktualizowany, dzięki czemu kategorie i poradniki pozostają przydatne z czasem.',
      f4title: 'Stworzone dla fanów',
      f4text: 'Od koszulek sportowych po akcesoria — struktura odzwierciedla to, czego naprawdę szukają fani i kupujący.',
    },
    guide: {
      title: 'Polecany poradnik',
      cardTitle: 'USFans Spreadsheet: Kompletny poradnik',
      cardDesc: 'Dowiedz się, czym jest spreadsheet, co w nim znajdziesz, jak go używać, oraz poznaj praktyczne wskazówki — plus poręczna tabela porównawcza i FAQ.',
      cardCta: 'Przeczytaj poradnik',
      cardDate: 'Aktualizowane regularnie',
    },
    articles: {
      title: 'Poradniki i artykuły',
      subtitle: 'Szczegółowe poradniki o USFans spreadsheet, recenzje, wysyłka, kupony, bezpieczeństwo i więcej.',
      readMore: 'Czytaj artykuł',
    },
    faq: {
      title: 'Często zadawane pytania',
      q1: 'Czym jest USFans Spreadsheet?',
      a1: 'To katalog oparty na kategoriach, który porządkuje popularne amerykańskie gadżety i odzież dla fanów w prostą, przejrzystą strukturę z bezpośrednimi linkami do każdej kolekcji.',
      q2: 'Jak korzystać z linków kategorii?',
      a2: 'Wybierz kategorię z listy rozwijanej lub kliknij dowolną kartę kategorii. Zostaniesz przeniesiony bezpośrednio do pasującej kolekcji na głównej stronie.',
      q3: 'Czy to oficjalna strona USFans?',
      a3: 'Nie. To niezależne źródło informacji, które linkuje do głównej strony, gdzie faktycznie sprzedawane są produkty.',
      q4: 'Czy muszę zakładać konto, aby przeglądać?',
      a4: 'Konto nie jest wymagane. Możesz przeglądać każdą kategorię i czytać każdy poradnik całkowicie za darmo.',
      q5: 'Jak dotrzeć do głównej strony?',
      a5: 'Użyj przycisków "usfans spreadsheet" lub "kup teraz", albo dowolnego linku kategorii — wszystkie prowadzą do głównej strony.',
    },
    cta: {
      title: 'Gotowy do odkrywania?',
      text: 'Przeglądaj wszystkie kategorie lub przejdź bezpośrednio do głównej strony, aby zobaczyć pełną kolekcję.',
      button: 'Odwiedź główną stronę',
      button2: 'usfans spreadsheet',
    },
  },
};